import React from "react";
import { FaUser } from "react-icons/fa";

const OwnerInfo = ({ user }) => {
  if (!user) return null;

  const userName = user.full_name || user.name || "Unknown User";

  return (
    <div
      style={{
        display: "inline-flex",
        alignItems: "center",
        gap: "8px",
        padding: "6px 12px",
        backgroundColor: "#eff6ff",
        borderRadius: "6px",
        border: "1px solid #bfdbfe",
        marginBottom: "1.5rem",
      }}
    >
      <FaUser style={{ fontSize: "12px", color: "#2563eb" }} />
      <div style={{ fontSize: "13px", color: "#1f2937" }}>
        <span style={{ fontWeight: "500" }}>Owner:</span> {userName}
      </div>
    </div>
  );
};

export default OwnerInfo;
